<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="mdi mdi-spin mdi-loading text-gray-500"></i>
        </div>
        <div v-else-if="failed" class="text-danger text-center">
            <i class="mdi mdi-warning"></i> An error occurred while fetching the voucher balance.
        </div>
        <div v-else>
            <div v-if="hasBalance">
                {{ balance.currency }} {{ balance.value }}
            </div>
            <div v-else class="text-center text-muted">
                <i class="mdi mdi-information"></i> Oops. No balance found.
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "VoucherBalance",
    props: {
        voucherUuid: {
            type: String,
            required: true
        }
    },
    data: () => ({
        loading: false,
        failed: false,
        hasBalance: false,
        balance: {
            currency: null,
            value: null
        }
    }),

    mounted () {
        this.fetchVoucherBalance();
    },

    methods: {
        fetchVoucherBalance() {
            this.loading = true;
            axios.get('/admin/api/vouchers/' + this.voucherUuid+ '/balance').then((res) => {
                this.loading = false;
                this.hasBalance = true;
                Object.assign(this.balance, res.data);
            }).catch((err) => {
                this.loading = false;

                if (err.response.status === 404) {
                    this.hasBalance = false;
                    return;
                }

                this.failed = true;
            })
        }
    },
}
</script>
